import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultNavbar from "hanyeleo/Navbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
import Axios from "utils/Axios";
import truncate from "truncate-html";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import getNavRoutes from "../../navroutes";
import Slide from "@mui/material/Slide";
import { useDispatch } from 'react-redux';
import { setGallery } from  "../../redux/slices/gallery/gallerySlice";
import { setRedirectUrl } from "../../redux/slices/auth/authSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { weekday: "short", day: "2-digit", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
};

const imageUrl = (url) => {
  return process.env.REACT_APP_BASE_IMAGE_URL + url;
};

const EventDetails = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [events, setEvents] = useState(null);
  const [showDescription, setShowDescription] = useState(true);
  const [images, setImages] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const token = localStorage.getItem("token");
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const galleryImageUrl = (image) => {
    const parts = image.split('_');
    if (parts.length >= 3) {
      parts.splice(3, 0, 'img_250');
      image = parts.join('_');
    }
    return `${process.env.REACT_APP_BASE_IMAGE_URL}gallery/${image}`;
  };
  
  const [routes, setNavRoutes] = useState([]);
  const navigate = useNavigate();

  const truncateHtml = (htmlContent, length = 100) => {
    return truncate(htmlContent, {
      length: length,
      ellipsis: "...",
      keepImageTag: true,
    });
  };

  const gotoEventDetails = (eId) => {
    setEvent(null);
    navigate(`/event/${eId}`);
    fetchEventDetails();
  };

  const fetchEventDetails = async () => {
    Axios.get(`?type=event&id=${eventId}`)
      .then((response) => {
        setEvent(response.data);
        fetchPromoterEvents(response.data.promoter_id);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
      });
  };

  const fetchPromoterEvents = async (id) => {
    Axios.get(`?type=event&promoter_id=${id}`)
      .then((response) => {
        setEvents(response.status == 204 ? [] : response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
      });
  };

  const getEventMedia = () => {
    Axios.get(`?type=eventMedia&event_id=${eventId}`)
      .then((response) => {
        setImages(response.data || []); 
      })
      .catch((error) => {
        console.error("Error fetching event media:", error);
      });
  };

  useEffect(() => {
    setNavRoutes(getNavRoutes(token ? true : false));
    if (token) {
      setIsLoggedIn(true);
    }
    fetchEventDetails();
    getEventMedia();
  }, [eventId]);

  if (!event) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="relative inline-block">
            <div className="animate-spin rounded-full h-24 w-24 border-b-4 border-purple-600"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-3xl">🎉</span>
            </div>
          </div>
          <p className="mt-6 text-xl font-semibold text-gray-700">Loading event details...</p>
        </div>
      </div>
    );
  }

  const maxImagesToShow = !isLoggedIn ? 4 : images.length;

  const handleImageClick = (imageIndex, imageId) => {
    if (!isLoggedIn) {
      const redirectUrl = `/event-image/${imageIndex}/${eventId}/${imageId}`;
      dispatch(setRedirectUrl(redirectUrl));
      setShow(true);
    } else {
      navigate(`/event-image/${imageIndex}/${eventId}/${imageId}`);
    }
  };

  const handleButtonClick = () => {
    if(event.location_url == null || event.location_url == ""){
      return
    }
    window.open(event.location_url, "_blank", "noopener,noreferrer");
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50 to-gray-100">
      <DefaultNavbar routes={routes} relative center />
      
      {/* Mobile Image */}
      <div className="sm:hidden">
        <img
          src={imageUrl(event.image)}
          alt={event.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Enhanced Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-900 via-purple-800 to-pink-700 py-12 md:py-16">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-64 h-64 bg-white rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-64 h-64 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-700"></div>
        </div>

        <Container className="relative z-10">
          <div className="flex flex-col-reverse md:flex-row justify-between items-center gap-8">
            <div className="flex flex-col p-6 md:p-0 text-white flex-1">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
                {event.title}
              </h1>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-3 border border-white/20 w-fit">
                  <span className="text-2xl">📅</span>
                  <div>
                    <p className="text-sm text-gray-200">Date</p>
                    <p className="font-bold text-lg">{formatDate(event.date)}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-3 border border-white/20 w-fit">
                  <span className="text-2xl">🕐</span>
                  <div>
                    <p className="text-sm text-gray-200">Time</p>
                    <p className="font-bold text-lg">{event.time}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-3 border border-white/20 w-fit">
                  <span className="text-2xl">🎭</span>
                  <div>
                    <p className="text-sm text-gray-200">Promoter</p>
                    <p className="font-bold text-lg">{event.promoter}</p>
                  </div>
                </div>

                {event.venue_name && (
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-3 border border-white/20 w-fit">
                    <span className="text-2xl">🏛️</span>
                    <div>
                      <p className="text-sm text-gray-200">Venue</p>
                      <p className="font-bold text-lg">{event.venue_name}</p>
                    </div>
                  </div>
                )}
              </div>

              <button
                type="button"
                className="group relative px-8 py-4 bg-gradient-to-r from-yellow-400 to-pink-500 text-white font-bold rounded-xl shadow-2xl hover:shadow-pink-500/50 transform hover:scale-105 transition-all duration-300 overflow-hidden w-fit"
                onClick={handleButtonClick}
              >
                <span className="relative z-10 flex items-center gap-2">
                  <span>📍</span>
                  {event.location}
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>

            {/* Desktop Image */}
            <div className="hidden sm:block flex-1 max-w-md">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 rounded-3xl blur-2xl opacity-30 animate-pulse"></div>
                <img
                  src={imageUrl(event.image)}
                  alt={event.title}
                  className="relative z-10 w-full rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Event Gallery Section */}
      <Container sx={{ mt: 8, mb: 8 }}>
        {event?.date && new Date(event?.date) < new Date() ? (
          images.length > 0 ? (
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-purple-100">
              <div className="flex items-center gap-3 mb-8">
                <span className="text-4xl">📸</span>
                <h2 className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600">
                  Event Gallery
                </h2>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[0, 1, 2, 3].map((col) => (
                  <div key={col} className="grid gap-4">
                    {images
                      .slice(0, maxImagesToShow)
                      .filter((_, index) => index % 4 === col)
                      .map((image, index) => (
                        <div 
                          key={image.id || index}
                          className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
                          onClick={() => handleImageClick(image.title, image.id)}
                        >
                          <img
                            className="h-auto w-full object-cover rounded-2xl group-hover:scale-110 transition-transform duration-700"
                            src={galleryImageUrl(image.title)}
                            alt={image.title}
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-purple-900/80 via-purple-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl flex items-center justify-center">
                            <span className="text-white font-bold text-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                              View Full Size
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                ))}
              </div>

              {/* Login Dialog */}
              <Dialog
                open={show}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                  style: {
                    borderRadius: '24px',
                    padding: '8px',
                  }
                }}
              >
                <DialogTitle className="text-2xl font-bold text-purple-700">
                  🔐 Login Required
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description" className="text-base">
                    To view images in full size, please{" "}
                    <a href="/sign-up/" className="text-purple-600 font-semibold hover:underline">
                      create a free account
                    </a>{" "}
                    or{" "}
                    <a href="/sign-in/" className="text-purple-600 font-semibold hover:underline">
                      log in here
                    </a>
                    . You'll be redirected to this image after login.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button 
                    onClick={handleClose}
                    className="text-purple-600 font-semibold"
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Signup Prompt */}
              {!isLoggedIn && images.length > 4 && (
                <div className="text-center mt-8 p-6 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl border-2 border-purple-200">
                  <p className="text-lg text-gray-800">
                    <span className="font-bold">Want to see the full gallery?</span>{" "}
                    <a href="/sign-up/" className="text-purple-700 font-bold hover:underline">
                      Create a free account
                    </a>{" "}
                    to unlock all {images.length} images! 🎉
                  </p>
                </div>
              )}
            </div>
          ) : null
        ) : null}

        {/* Event Details Section */}
        {(new Date(event?.date) > new Date() || showDescription) && (
          <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-purple-100 mt-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-4xl">📋</span>
              <h2 className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600">
                Event Details
              </h2>
            </div>

            <div
              className="prose prose-lg max-w-none text-gray-700 leading-relaxed"
              style={{
                '& p': { marginBottom: '1rem' },
                '& img': { maxWidth: '100%', height: 'auto', marginBottom: '1rem', borderRadius: '12px' },
                '& h2, & h3, & h4, & h5, & h6': { marginTop: '1.5rem', marginBottom: '0.5rem', fontWeight: 'bold' },
                '& ul, & ol': { marginLeft: '2rem', marginBottom: '1rem' },
              }}
              dangerouslySetInnerHTML={{ __html: event.description }}
            />
          </div>
        )}
      </Container>

      {/* More from Promoter Section */}
      {events?.length > 0 && (
        <Container sx={{ mt: 8, mb: 8 }}>
          <div className="mb-8">
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900">
              <span className="border-b-4 border-purple-600 pb-2">More</span> from {event.promoter}
            </h2>
          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
            {events?.map((evt) => {
              if (evt.id !== eventId) {
                return (
                  <div
                    onClick={() => gotoEventDetails(evt.id)}
                    key={evt.id}
                    className="group bg-white rounded-2xl p-6 border-2 border-gray-100 shadow-lg hover:shadow-2xl hover:border-purple-300 transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
                  >
                    <div className="flex gap-4 mb-4">
                      <Avatar
                        alt={evt.title}
                        src={imageUrl(evt.image)}
                        sx={{ width: 64, height: 64 }}
                        variant="rounded"
                        className="ring-2 ring-purple-200 group-hover:ring-purple-400 transition-all duration-300"
                      />
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-gray-900 group-hover:text-purple-700 transition-colors duration-300 line-clamp-2">
                          {evt.title}
                        </h3>
                        <p className="text-sm text-purple-600 font-medium flex items-center gap-1 mt-1">
                          <span>📍</span>
                          {evt.location}
                        </p>
                      </div>
                    </div>

                    <div
                      className="text-sm text-gray-600 mb-4 line-clamp-3"
                      dangerouslySetInnerHTML={{
                        __html: truncateHtml(evt.description, 100),
                      }}
                    />

                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                      <p className="text-xs text-gray-500 flex items-center gap-2">
                        <span>📅</span>
                        {evt.date}, {evt.time}
                      </p>
                      <Icon className="text-purple-600 group-hover:translate-x-1 transition-transform duration-300">
                        arrow_forward
                      </Icon>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </Container>
      )}

      <DefaultFooter content={footerRoutes} />
    </div>
  );
};

export default EventDetails;